interface ICustomError {
  code: string;
  error: string;
  message: string;
}

export const isError = (error: Error | ICustomError) => {
  return (
    (error && (error as Error).stack && error.message) ||
    (error &&
      (error as ICustomError).code &&
      (error as ICustomError).error &&
      error.message)
  );
};
